import { UseChatbotMonarchReturnType } from "../useChatbotMonarch";
import { ChatbotState } from "~/types/chatbot";

export type ChatType = "GIGA" | "PROACTIVE_V1" | "PROACTIVE_V2" | "DISABLED";

/**
 * Determines if any chatbot feature is enabled based on Monarch flags
 */
export const isFeatureEnabled = (monarchFlags: UseChatbotMonarchReturnType): boolean => {
  if (monarchFlags.isLoading) return false;
  return monarchFlags.chatType !== undefined;
};

/**
 * Maps Monarch chatType to internal ChatType enum
 */
export const getChatType = (monarchFlags: UseChatbotMonarchReturnType): ChatType => {
  if (monarchFlags.chatType === "Giga") return "GIGA";
  if (monarchFlags.chatType === "ProactiveV2") return "PROACTIVE_V2";
  if (monarchFlags.chatType === "Proactive") return "PROACTIVE_V1";
  return "DISABLED";
};

/**
 * Determines if chatbot should be visible based on status and loading state
 */
export const shouldShowChatbot = (status: ChatbotState["status"], isLoading: boolean): boolean => {
  if (isLoading) return false;
  return status === "GIGA_CHAT_VISIBLE" || status === "PROACTIVE_CHAT_VISIBLE";
};

/**
 * Determines if proactive chat should be shown
 */
export const shouldShowProactiveChat = (chatType: ChatType, isLoading: boolean): boolean => {
  if (isLoading) return false;
  return chatType === "PROACTIVE_V1" || chatType === "PROACTIVE_V2";
};

/**
 * Determines if giga chat should be shown
 */
export const shouldShowGigaChat = (chatType: ChatType, isLoading: boolean): boolean => {
  if (isLoading) return false;
  return chatType === "GIGA";
};
